export interface ApiErrorOptions {
  details?: Record<string, string[]>;
  data?: unknown;
  retryAfterSeconds?: number;
}

export class ApiError extends Error {
  public details?: Record<string, string[]>;

  // The response body as sent. Some endpoints answer an error with structured data the
  // caller has to act on (a conflict to resolve, say), and `message` alone drops it.
  public data?: unknown;

  public retryAfterSeconds?: number;

  constructor(
    message: string,
    public status: number,
    { details, data, retryAfterSeconds }: ApiErrorOptions = {},
  ) {
    super(message);
    Object.setPrototypeOf(this, ApiError.prototype);
    this.name = "ApiError";
    this.details = details;
    this.data = data;
    this.retryAfterSeconds = retryAfterSeconds;
  }
}
